const PbxxRecord = require('../pbxx_record')

module.exports = class FacebookPage extends PbxxRecord {
  static get class_name() {
    return 'FacebookPage'
  }
}
